import React from 'react';
import { Link } from 'react-router-dom';

const TrainerCard = ({ profile_img, full_name = "", first_name, last_name, name = "", location = { city: "", state: "", country: "" }, clients_coached = "", about_description = "", certification_tags = [], designation = "", experience_yrs = 1, languages, training_types, guaranteed, phone_no = "0000000000", user_name = null, availability = "Online/Offline", ...trainerProps }) => {

    // const user_name = getFullName({ first_name: first_name, last_name: last_name })

    const locality = `${!!location?.city ? location?.city + ', ' : ''}${!!location?.state ? location?.state + ', ' : ''}${!!location?.country ? location?.country : ''}`;

    const LocationAndAmenities = () => {
        return (
            <div className='flex-grow flex flex-1 flex-col justify-between items-end gap-x-4 md:gap-x-6 '>
                <div className="w-full flex flex-row flex-wrap md:flex-nowrap items-start md:gap-7">
                    <div className='w-1/2 md:w-1/4 flex flex-col items-start py-2 md:py-0'>
                        <p className="text-gray-300 text-sm font-medium">Location</p>
                        <p className="text-white font-semibold text-[0.75rem]">{locality}</p>
                    </div>
                    <div className='w-1/2 md:w-1/6 flex flex-col items-start py-2 md:py-0'>
                        <p className="text-gray-300 text-sm font-medium">Coached</p>
                        <p className="text-white font-semibold text-[0.75rem]">{clients_coached} Clients</p>
                    </div>
                    <div className='w-1/2 md:w-1/6 flex flex-col items-start py-2 md:py-0'>
                        <p className="text-gray-300 text-sm font-medium">Experience</p>
                        <p className="text-white font-semibold text-[0.75rem]">{experience_yrs} Year{(experience_yrs > 1 ? 's' : "")}</p>
                    </div>
                    <div className='w-1/2 md:w-1/4 flex flex-col items-start py-2 md:py-0'>
                        <p className="text-gray-300 text-sm font-medium">Language Spoken</p>
                        <p className="text-white font-semibold text-[0.75rem]">{(languages || ["English"]).join(" | ")}</p>
                    </div>
                    <div className='w-1/2 md:w-2/12 flex flex-col items-start py-2 md:py-0'>
                        <p className="text-gray-300 text-sm font-medium">Training</p>
                        <p className="text-white font-semibold text-[0.75rem]">{(availability || "")}</p>
                    </div>
                </div>
                {/* Contact Now Button (Right-aligned) */}
                <div className='hidden md:flex'>
                    <ContactButton />
                </div>
            </div>
        )
    }

    const ContactButton = () => {
        return (
            <a
                onClick={(e) => {
                    e.stopPropagation(); // ⛔ stop parent click
                }}
                href={`tel:${phone_no}`}
                className="flex-shrink-0 group flex items-center bg-white border border-gray-300 text-gray-900 font-medium p-[0.15rem] rounded-[0.6rem] rounded-tr-[0.3rem] shadow-sm hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 transition duration-200"
            >
                <span className="hidden md:flex px-2 font-urbanist text-xs font-semibold mr-1">Contact Now</span>
                <span className="flex items-center justify-center w-5 h-5 bg-black rounded-[0.53rem] rounded-tr-[0.3rem] p-1">
                    <img
                        className="transition-transform group-hover:scale-105"
                        src="/assets/individual/Call.png"
                        alt="Contact"
                    />
                </span>
            </a>
        )
    }

    return (
        <Link to={`/trainer/profile/${user_name}`} className="bg-gradient-radial p-3 rounded-xl font-urbanist flex flex-col md:flex-row  w-full max-w-6xl mx-auto mb-6 gap-3 shadow-lg shadow-[#171A26] hover:shadow-lg hover:scale-[1.01] transition-transform duration-200 border-t border-gray-900">
            <div className="flex flex-row justify-center items-start gap-3">
                {/* Gym Image */}
                <div className="flex-shrink-0 w-20 h-20 rounded-2xl rounded-tr-md overflow-hidden bg-gray-700 flex items-center justify-center">
                    {/* Placeholder for actual image */}
                    <img src={profile_img} alt="Trainer Profile" className="w-full h-full object-cover" />
                </div>

                {/* Column 1: Name, Assured Tag, Description */}
                <div className="md:w-48 flex flex-col items-start">
                    <div className="flex items-start mb-1">
                        <div className="text-md font-medium text-white">{full_name}</div>
                        {guaranteed && (
                            <span className="ml-3 mt-1 px-2 py-0 bg-white text-black text-xs font-semibold rounded-full">
                                Guaranteed
                            </span>
                        )}
                    </div>
                    <p className="text-[0.75rem] text-gray-400 leading-relaxed line-clamp-1">
                        {designation}
                    </p>
                    <p className="text-[0.75rem] text-gray-400 leading-relaxed line-clamp-4 mt-1">
                        {certification_tags.join(', ')}<br />
                        {about_description}
                    </p>
                </div>
                <div className='md:hidden flex flex-col items-start'>
                    <ContactButton />
                </div>
            </div>

            {/* Main Content Area */}
            <LocationAndAmenities />
        </Link>
    );
};

export { TrainerCard };